import type { FaireProductEntity } from "../../entity_types/product";

export const p_qyg79pvudt: FaireProductEntity = {
  token: "p_qyg79pvudt",
  type: "product",
  name: "Alfredo Sauce",
  brandToken: "b_mk6jmayu79",
  brandName: "A Very Good Pasta Sauce",
  imageUrl:
    "https://cdn.faire.com/fastly/36b1b2d937eccb3676944ceab2684acc65e2016d1d3da746570ae4057b507715.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9667a43ca5d8045a6aa105f1729799e8c3eff518b38eddca8fcf7d317030b046.jpeg",
    "https://cdn.faire.com/fastly/16ac03552dba5b2f30c11698654c7c23834c223e2b8f40db6e540d8c8e1386a2.jpeg",
  ],
  priceDollars: 4.85,
  description:
    "Indulge in the exquisite blend of flavors with our unique Alfredo Pasta Sauce. Crafted with the freshest ingredients and a touch of culinary mastery, this sauce promises to elevate your pasta dishes to new heights of deliciousness.\n\nOur recipe begins with the finest Homo Milk, selected for its rich creaminess, which forms the creamy base of our sauce. To enhance the texture and richness, we add a dash of luxurious cream, creating a velvety smooth consistency that coats every strand of pasta perfectly.\n\nInfused with the savory essence of onions and garlic, our Alfredo sauce boasts a depth of flavor that is simply irresistible. Each bite is punctuated with the nutty undertones of Parmesan cheese, carefully grated to impart a decadent creaminess and a hint of umami goodness.\n\nTo accentuate the taste profile, we drizzle in premium olive oil, adding a subtle fruitiness and silkiness to the sauce. A pinch of Himalayan salt lends a delicate balance, while freshly ground black pepper provides ",
  tags: [],
  msrpDollars: 7.7,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-06T18:25:18.141Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
